// import sdk from 'redcatSdk'
import axios from '../axios'
import { UUID } from '@/plugins/common'
import moment from 'moment'

export const forms = {
}

export const processes = {
  // '16AC4483-AB50-186F-AA0E-FCDE134F8B7D': (context) => {
  //   sdk.http.get('/test-api/hello-world')
  //   sdk.message.info('hello world')
  // }
  // 合作商提升店报备
  '170B824B-5660-006D-2598-DE56CC29BD8F': ({ eventBus, process, el }) => {
    eventBus.$on('process.beforeSubmit', async ({ params, currentNode }) => {
      // 总经理审批
      if (process.dataService.data['172924E8-E830-0060-F0C6-4ED393B7DB44'] === '否' && currentNode.id === '_170B826A-BB20-007B-17E9-8C62AD70257B' && params.actionId === '_170B826A-BB20-007D-2A7F-64CF7CFBCF96') {
        await axios.post('/huaao-api/process/improveStore', params)
      }
      // 区域总审批
      if (process.dataService.data['172924E8-E830-0060-F0C6-4ED393B7DB44'] === '是' && currentNode.id === '_170B826B-2D40-008E-D38B-2E37052042EA' && params.actionId === '_170B826B-2D40-0090-6ACB-D0C6C3E0CBAF') {
        await axios.post('/huaao-api/process/improveStore', params)
      }
    })
  },
  // 调店流程(提高加载速度，迁移到平台项目)
  '16AC4511-4480-2173-B824-BDF9BF8C5816': ({ eventBus, process, el }) => {
    if (process.currentNode !== undefined && process.currentNode.id === "_17A8A700-4F30-008B-EEF9-D88AD22AE14E") {
      process.currentNode.actions.pop()
    }
    eventBus.$on('process.beforeStartingProcess', async ({ params, currentNode }) => {
      if (currentNode.id === '_169F1B09-BE40-417E-811F-76FC766DA220') {
        // 发起节点(调店申请) - 判断当前合作商是否有培训时间
        let data = process.dataService.data['169F1B1F-5E04-C51B-B711-783705F51A11'].map(e => {
          return e['169F1B32-9080-A594-DD78-0870A577DCB4']
        })
        await axios.post('/huaao-api/partnerManage/getTrainStartTime', data).then(res => {
          let notAllowedPartner = []
          if (res.data.status === 1) {
            notAllowedPartner = res.data.list.filter(e => {
              return !e.trainStartTime
            })
          }
          // 如果存在无培训开始时间的合作商则提示用户,并禁止流程流转
          if (notAllowedPartner.length !== 0) {
            let partnerName = notAllowedPartner.map(e => { return e.partnerName }).join()
            el.$message.error(`${partnerName}无首次培训时间,不能进行调店操作,请发起培训流程或联系培训部!`)
            throw new Error('存在无首次培训时间合作商,流程不流转')
          }
        })
        // 测调店情况为“调入”的合作商，如果在驻店管理表中，（木有离店时间或离店时间大于“生效日期”）的人数大于5人则提示
        // 169F1B3F-EF70-80E4-B491-914B1CFE113C 调入  169F1B32-9080-A594-DD78-0870A577DCB4  合作商id  169F1B7C-9580-A92C-A664-597A6EC1662A date
        let mingxiList = process.dataService.data['169F1B1F-5E04-C51B-B711-783705F51A11']
        let list = []
        mingxiList.forEach((item) => {
          if (item['169F1B3F-EF70-80E4-B491-914B1CFE113C'] === '调入') {
            let obj = {}
            obj.partnerId = item['169F1B32-9080-A594-DD78-0870A577DCB4']
            obj.date = item['169F1B7C-9580-A92C-A664-597A6EC1662A']
            list.push(obj)
          }
        })
        await axios.post('/huaao-api/process/checkManagerNumber', list)
        await axios.post('/huaao-api/process/TransferInStatistics', mingxiList).then(res => {
          if(res.data === "0" || res.data === 0){
            process.dataService.data["17A98936-ADC0-00BE-242A-4EB0C71EACFA"] = 0
          }
        })
        if (process.dataService.data["17A98936-ADC0-00BE-242A-4EB0C71EACFA"] === 0) {
          // 如果驻店人数为0，则需要加载单证回收明细数据
          let filArr = process.dataService.data["169F1B1F-5E04-C51B-B711-783705F51A11"]
          let newFilArr = [];
          filArr.filter( (item,i) =>{
            if(item["169F1B32-9080-A594-DD78-0870A577DCB4"]){
              newFilArr.push(item["169F1B32-9080-A594-DD78-0870A577DCB4"])
            }
          })
          if (newFilArr.length > 0) {
            let params = { index: -1, size: 100, filters: { '17A8A84B-C120-00CC-076D-769AF382B5C9': newFilArr.toString().replace(",",", ") } }
            await axios.get('/report-api/report/data/17A8A842-F9C0-00B4-D195-0FD44304019F', {params}).then((res) => {
              process.dataService.data["17A8A727-7E80-00AD-A518-89917F677F55"] = []
              res.data.forEach((n,i) => {
                let info = {
                    id: UUID.create(),
                    '17A8A733-93F0-00B0-7832-9D827A3D5489': n['17A8A899-D0A0-00EB-E6A4-B7A322E42074'],
                    '17A8A72A-AA60-00AE-5033-C83589B73DFA': n['17A8A847-DBD0-00BA-ACC4-BFB2CC38E600'],
                    '17A8A735-06E0-00B2-3592-16BAAE1C2149': parseInt(n['17A8A871-AE60-00D6-6C53-31FB9995F606']) + 1,
                    '17A8A735-86B0-00B4-1730-627B7928BC71': n['17A8A849-1F80-00C2-D3A8-76297671430C'],
                }
                process.dataService.data["17A8A727-7E80-00AD-A518-89917F677F55"].push(info)
              })
            })
          }
        }
      }
    })
    eventBus.$on('process.beforeSubmit', async ({ params, currentNode }) => {
      if (currentNode.id === '_169F1BC0-B710-3675-CBA8-1D98A126A935') {
        // 总经理审批节点
        params.nodeId = currentNode.id
        if (params.actionId === '_169F1BC0-B712-F50E-0505-0B9BD90D4859') {
          await axios.post('/huaao-api/process/updateTiaoDianInfo', params)
        }
        await axios.post('/huaao-api/process/completeTask', params)
          .then(() => {
            if (params.actionId === '_169F1BC0-B712-F50E-0505-0B9BD90D4859') {
              axios.post('/huaao-api/process/sendEmailAfterChangeShop', params)
            }
            el.$emit('closeDialog', 'process')
            throw new Error('')
          })
      }
    })
    eventBus.$on('component.init', ({ component, el }) => {
      // 调店流程，单证回收节点，因为此节点自动流转，前端定制代码不运行，已将功能迁移至发起节点发起之前加载
      if (component.componentId === 'kqw3e2n8') {
        let filArr = el.dataService.data["169F1B1F-5E04-C51B-B711-783705F51A11"]
        let newFilArr = [];
        filArr.filter( (item,i) =>{
          newFilArr.push(item["169F1B32-9080-A594-DD78-0870A577DCB4"])
        } )
        if (newFilArr.length >0) {
          let params = { index: -1, size: 100, filters: { '17A8A84B-C120-00CC-076D-769AF382B5C9': newFilArr.toString().replace(",",", ") } }
          axios.get('/report-api/report/data/17A8A842-F9C0-00B4-D195-0FD44304019F', {params}).then((res) => {
            el.dataService.data["17A8A727-7E80-00AD-A518-89917F677F55"] = []
            res.data.forEach((n,i) => {
              let info = {
                id: UUID.create(),
                '17A8A733-93F0-00B0-7832-9D827A3D5489': n['17A8A899-D0A0-00EB-E6A4-B7A322E42074'],
                '17A8A72A-AA60-00AE-5033-C83589B73DFA': n['17A8A847-DBD0-00BA-ACC4-BFB2CC38E600'],
                '17A8A735-06E0-00B2-3592-16BAAE1C2149': parseInt(n['17A8A871-AE60-00D6-6C53-31FB9995F606']) + 1,
                '17A8A735-86B0-00B4-1730-627B7928BC71': n['17A8A849-1F80-00C2-D3A8-76297671430C'],
              }
              el.dataService.data["17A8A727-7E80-00AD-A518-89917F677F55"].push(info)
            })
          })
        }
      }
      // 调店申请详细内容 - 生效日期控件
      if (component.componentId === '16AC4511-4550-2183-1FC2-86133F9BC623') {
        // 只能选今天及以后的日期
        let pickerOptions = {
          disabledDate (time) {
            return time.getTime() < Date.now() - 60 * 60 * 24 * 1000
          }
        }
        el.$set(component.properties, 'pickerOptions', pickerOptions)
      }
    })
  },
  // 调休申请
  '16AC4475-0550-1836-C196-3A6E6B58C1AA': ({ eventBus, process, el }) => {
    eventBus.$on('process.beforeStartingProcess', async ({ params, currentNode }) => {
      if (currentNode.id === '_16976426-8760-1464-6915-13D6D14BBD1E') {
        let dayOfRest = process.dataService.data['16976517-8AF0-68CA-2EF6-2E86C5672D78']
        let workDay = process.dataService.data['1697651B-E3F0-55A4-9FDF-8C26FC0ECDE3']
        let postName = process.dataService.data['1697650C-2E60-92C4-81D7-9D3B0E8BB472']
        if (postName.indexOf('客户经理') > -1) {
          let checkData = {
            index: 1,
            size: 20,
            filters: {
              '172DED9F-0930-21C5-A248-CE7BF922F8F3': dayOfRest
            }
          }
          await axios.get(`/report-api/report/data/172DED9F-0930-21C3-A8EC-809E04877C13`, {params: checkData}).then(res => {
            if (res.data.length > 0) {
              el.$message.error('休息日不能为法定节假日')
              throw new Error()
            }
          })
          checkData.filters['172DED9F-0930-21C5-A248-CE7BF922F8F3'] = workDay
          await axios.get(`/report-api/report/data/172DED9F-0930-21C3-A8EC-809E04877C13`, {params: checkData}).then(res => {
            if (res.data.length > 0) {
              el.$message.error('调至日期不能为法定节假日')
              throw new Error()
            }
          })
          await axios.get(`/huaao-api/process/checkDayOfRest?dayOfRest=${dayOfRest}`).then(res => {
            if (Object.keys(res.data).length !== 0) {
              let restDay1 = res.data.dayOfRest1
              let restDay2 = res.data.dayOfRest2
              let dateRest = dayOfRest.split('-')
              var ndate = new Date(dateRest[0], parseInt(dateRest[1] - 1), dateRest[2])
              var weekArray = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
              var weekDay = weekArray[ndate.getDay()]
              if (restDay1 !== weekDay && restDay2 !== weekDay) {
                el.$message.warning('所选休息日期有误')
                throw new Error()
              }
            }
          })
          await axios.get(`/huaao-api/process/checkDayOfRest?dayOfRest=${workDay}`).then(res => {
            if (Object.keys(res.data).length !== 0) {
              let wordDay1 = res.data.dayOfRest1
              let wordDay2 = res.data.dayOfRest2
              let datework = workDay.split('-')
              var wdate = new Date(datework[0], parseInt(datework[1] - 1), datework[2])
              var weekArray = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
              var workDate = weekArray[wdate.getDay()]
              if (wordDay1 === workDate || wordDay2 === workDate) {
                el.$message.warning('所选调至日期有误')
                throw new Error()
              }
            }
          })
        }
      }
    })
    eventBus.$on('process.beforeSubmit', async ({ params, currentNode }) => {
      if (currentNode.id === '_1697648B-6E60-840F-9838-87D56C70E6CC') {
        let workDay = process.dataService.data['1697651B-E3F0-55A4-9FDF-8C26FC0ECDE3']
        let postName = process.dataService.data['1697650C-2E60-92C4-81D7-9D3B0E8BB472']
        if (postName.indexOf('客户经理') > -1) {
          await axios.get(`/huaao-api/process/checkSeriesRest?date=${workDay}`).then(res => {
            if (res.data) {
              process.dataService.data['1719C39E-FCD0-0398-015C-17125295A88E'] = 1
            }
          })
        }
      }
    })
  },
  // 投诉处理流程
  '16B969E1-D530-0038-CC73-95C8D148AF68': ({ eventBus, process, el }) => {
    let oldTime = process.dataService.data['16E6DBF6-2390-03BC-F925-D6D793577770']
    let result, solution
    eventBus.$on('component.init', async ({ component }) => {
      // 去除必填校验
      if (component.componentId === '16C27300-69A0-02D7-E0A1-795C6B0C316A') {
        result = el.findAllVue(el).find(e => e.component.componentId === '16B96B60-A870-012C-01AB-FD1F2556F025')
        solution = el.findAllVue(el).find(e => e.component.componentId === '16C27300-69A0-02D7-E0A1-795C6B0C316A')
        result.component.properties.required = false
        solution.component.properties.required = false
      }
      if (component.componentId === '16C2731D-7B90-02E1-5139-07B5A0E66E13') {
        let result = el.findAllVue(el).find(e => e.component.componentId === '16B97FA6-1250-032C-A838-3AACFEFF6BD4')
        let solution = el.findAllVue(el).find(e => e.component.componentId === '16C2731D-7B90-02E1-5139-07B5A0E66E13')
        result.component.properties.required = false
        solution.component.properties.required = false
      }
    })
    eventBus.$on('process.beforeSubmit', async ({ params, currentNode }) => {
      if (currentNode.id === '_16B969F0-4F50-0046-5A02-CFA437918EA6') {
        if (params.actionId === '_16EB0D90-2470-007C-95D9-03B2037B5515') {
          if (!process.dataService.data['16E6D1B8-6C10-0157-7E76-9B265294BE2C']) {
            el.$message({
              message: '请填写延期原因！',
              type: 'error'
            })
            throw new Error()
          }
          // 申请延期按钮
          // 员工处理节点 - 申请延期按钮
          // 通过是否延期（员工）判断按钮点过没有
          if (process.dataService.data['16EAACA8-1420-0468-5397-92B82280959A'] && process.dataService.data['16EAACA8-1420-0468-5397-92B82280959A'] === '是') {
            el.$message({
              message: '只许延期一次',
              type: 'error'
            })
            throw new Error()
          }
          if (oldTime !== process.dataService.data['16E6DBF6-2390-03BC-F925-D6D793577770']) {
            el.$message({
              message: '只许延期一次',
              type: 'error'
            })
            throw new Error()
          }
          let startTime = new Date(process.dataService.data['16E6DBF6-2390-03BC-F925-D6D793577770'].replace(new RegExp(/-/gm), '/')).getTime() + 8 * 3600 * 1000
          let endTime = new Date(startTime + 3600 * 1000 * 24 * 5)
          let m = endTime.getMonth() + 1
          let d = endTime.getDate()
          let resDate = endTime.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' 00' + ':' + '00' + ':' + '00'
          await axios.post('/huaao-api/process/updateOverdueDate', {
            id: process.dataService.data.id,
            date: resDate,
            role: '员工'
          }).then(() => {
            process.dataService.data['16E6DBF6-2390-03BC-F925-D6D793577770'] = resDate
            process.dataService.data['16EAACA8-1420-0468-5397-92B82280959A'] = '是'
            // 流程数据暂存
            return axios.post('/process-api/runtime/stagingTask', params)
          }).then(() => {
            el.$message.success('申请延期成功')
            el.$router.go(-1)
            throw new Error('延期按钮不流转流程')
          })
        } else if (params.actionId === '_16B969F0-4F60-0048-B8B0-9BAB2C2CC05E') {
          if (!process.dataService.data['16B96B60-A870-012A-4EB0-D726128FB635']) {
            el.$message({
              message: '处理结果（员工）必填',
              type: 'error'
            })
            throw new Error('处理结果（员工）必填')
          }
          if (!process.dataService.data['16C27300-69A0-02D5-E2AD-7CDD70B1CB18']) {
            el.$message({
              message: '处理方案必填',
              type: 'error'
            })
            throw new Error('处理方案必填')
          }
        }
      } else if (currentNode.id === '_16B969F2-7000-0059-5EFF-34CC769BA73F') {
        if (params.actionId === '_16EB0D93-0030-007D-4CBB-D453F323DD67') {
          if (!process.dataService.data['16E6DC58-6670-044F-995F-6485B18332DE']) {
            el.$message({
              message: '请填写延期原因！',
              type: 'error'
            })
            throw new Error()
          }
          // 总经理处理节点 - 申请延期按钮
          // 通过是否延期（总经理）判断按钮点过没有
          if (process.dataService.data['16EAACC7-8C10-046B-4D28-42270B01F69D'] && process.dataService.data['16EAACC7-8C10-046B-4D28-42270B01F69D'] === '是') {
            el.$message({
              message: '只许延期一次',
              type: 'error'
            })
            throw new Error()
          }
          if (oldTime !== process.dataService.data['16E6DBF6-2390-03BC-F925-D6D793577770']) {
            throw new Error()
          }
          let startTime = new Date(process.dataService.data['16E6DBF6-2390-03BC-F925-D6D793577770'].replace(new RegExp(/-/gm), '/')).getTime() + 8 * 3600 * 1000
          let endTime = new Date(startTime + 3600 * 1000 * 24 * 7)
          let m = endTime.getMonth() + 1
          let d = endTime.getDate()
          let resDate = endTime.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' 00' + ':' + '00' + ':' + '00'
          await axios.post('/huaao-api/process/updateOverdueDate', {
            id: process.dataService.data.id,
            date: resDate,
            role: '总经理'
          }).then(() => {
            process.dataService.data['16E6DBF6-2390-03BC-F925-D6D793577770'] = resDate
            process.dataService.data['16EAACC7-8C10-046B-4D28-42270B01F69D'] = '是'
            // 流程数据暂存
            return axios.post('/process-api/runtime/stagingTask', params)
          }).then(() => {
            el.$message.success('申请延期成功')
            el.$router.go(-1)
            throw new Error('延期按钮不流转流程')
          })
        } else if (params.actionId === '_16B969F2-7000-005B-207E-876FFA86CE94') {
          if (!process.dataService.data['16B97FA6-1250-032A-397F-4D6E8A28955B']) {
            el.$message({
              message: '处理结果（总经理）必填',
              type: 'error'
            })
            throw new Error('处理结果（总经理）必填')
          }
          if (!process.dataService.data['16C2731D-7B90-02DF-CCA0-9B1ECD250481']) {
            el.$message({
              message: '处理方案（总经理）必填',
              type: 'error'
            })
            throw new Error('处理方案（总经理）必填')
          }
        }
      }
    })
  },
  // 督导派驻流程(提高加载速度，迁移到平台项目)
  '16AC453F-32C0-24FA-567B-7F683900DEDF': ({ eventBus, process, el }) => {
    eventBus.$on('component.init', ({ component }) => {
      if (component.componentId === '16AC453F-34A0-2546-CAA8-A4B7A960483E') {
        if (process.currentNode.id === '_16A35213-3310-02CD-73A3-8C7BA0EC0EBB') {
          // 经理审批
          // 出单件数
          // let times = []
          // process.dataService.data['16A42C4C-AAA1-9B8E-56F9-D310D76D324C'].forEach(e => times.push(e['16A42C50-6EC0-16BA-81DE-A3A459114B51']))
          // let params = {
          //   partner_id: process.dataService.data['16C41F24-01D0-00CB-8A30-BC332CB4CD3D'],
          //   except_date: times.join(','),
          //   startDate: process.dataService.data['16A34C1F-6390-A144-473C-8EEC9DA01BF9'],
          //   endDate: process.dataService.data['16A3522A-BDE0-A084-0C72-B24C81C27714']
          // }
          // if (params.except_date === '') {
          //   delete params.except_date
          // }
          // axios.post('/huaao-api/saleSupervision/getMyIssueCount', params).then(res => {
          //   // 销售件数
          //   process.dataService.data['16A42CC3-BEF0-80E1-9400-3CB875397646'] = res.data.data || 0
          // })
        }
      } else if (component.componentId === '16C18878-5D90-0064-38DB-200825BE9916') {
        if (process.currentNode.id === '_16A34C3C-B670-540C-B727-468E6A082FDE') {
          // 督导完成
          let params = {
            applyPartnerId: process.dataService.data['16CFA1BB-9E90-00AF-4A5A-C690FC878282'],
            signPartnerId: process.dataService.data['16A34D0D-3B70-61FC-2982-595874C16B33']
          }
          axios.get(`/huaao-api/attendance/isOffsite`, { params }).then((res) => {
            if (res.data) {
              // 是否异地
              process.dataService.data['16AD45CB-7C00-009E-A1B8-1490A0B75688'] = '是'
            } else {
              process.dataService.data['16AD45CB-7C00-009E-A1B8-1490A0B75688'] = '否'
            }
          })
        }
      }
    })
    eventBus.$on('process.beforeSubmit', async ({ params, currentNode }) => {
      if (process.currentNode.id === '_16A34C3C-B670-540C-B727-468E6A082FDE') {
        // 出单件数
        let times = []
        process.dataService.data['16A42C4C-AAA1-9B8E-56F9-D310D76D324C'].forEach(e => times.push(e['16A42C50-6EC0-16BA-81DE-A3A459114B51']))
        let params = {
          partner_id: process.dataService.data['16C41F24-01D0-00CB-8A30-BC332CB4CD3D'],
          except_date: times.join(','),
          startDate: process.dataService.data['16A34C1F-6390-A144-473C-8EEC9DA01BF9'],
          endDate: process.dataService.data['16A3522A-BDE0-A084-0C72-B24C81C27714']
        }
        if (params.except_date === '') {
          delete params.except_date
        }
        await axios.post('/huaao-api/saleSupervision/getMyIssueCount', params).then(res => {
          process.dataService.data['18CD24F7-C4A0-0333-6D9A-BD8827A53CA0'] = res.data.isMiddleToSeniorAccountManagers // 是否存在中高级客户经理出单
          process.dataService.data['16A42CC3-BEF0-80E1-9400-3CB875397646'] = res.data.data || 0
          process.dataService.data['16AD4661-BD10-0653-5609-F34E427FA38C'] = res.data.accountingSales // 核算销售额
          process.dataService.data['18DC054D-3D40-0953-BB68-CC383F446869'] = res.data.assessSalesRevenue // 考核销售额
        })
        let params1 = {
          starTime: process.dataService.data['16A34C1F-6390-A144-473C-8EEC9DA01BF9'],
          endTime: process.dataService.data['16A3522A-BDE0-A084-0C72-B24C81C27714'],
          supervisionId: process.dataService.data['16A34DA2-0370-A494-ABC9-A0E4B951D95A'],
          partnerId: process.dataService.data['16C41F24-01D0-00CB-8A30-BC332CB4CD3D'],
          id: process.dataService.data.id
        }
        await axios.post('/huaao-api/attendance/supervisionDeployment', params1).catch(()=>{
          message.error('系统异常，请稍后重试!')
          throw new Error('系统异常，请稍后重试!')
        })
      }
    })
    eventBus.$on('component.update', ({ component, value }) => {
      // 查询未考勤历史
      if (component.componentId === '16AC453F-33E0-2522-1E24-33424E18E96F') {
        // 派驻结束时间
        if (value) {
          let params = {
            startTime: process.dataService.data['16A34C1F-6390-A144-473C-8EEC9DA01BF9'],
            endTime: value,
            partnerId: process.dataService.data['16C41F24-01D0-00CB-8A30-BC332CB4CD3D']
          }
          axios.get('/huaao-api/attendance/getSignHistory', {params}).then(res => {
            // 未出勤明细表
            process.dataService.data['16A42C4C-AAA1-9B8E-56F9-D310D76D324C'] = []
            let dataArr = Object.keys(res.data)
            for (let i = 0; i < dataArr.length - 1; i++) {
              for (let j = 0; j < dataArr.length - 1 - i; j++) {
                if (new Date(dataArr[j].replace(new RegExp(/-/gm), '/')) > new Date(dataArr[j + 1].replace(new RegExp(/-/gm), '/'))) {
                  let temp = dataArr[j]
                  dataArr[j] = dataArr[j + 1]
                  dataArr[j + 1] = temp
                }
              }
            }
            dataArr.forEach((n, index) => {
              process.dataService.data['16A42C4C-AAA1-9B8E-56F9-D310D76D324C'].push({
                '16A42C50-6EC0-16BA-81DE-A3A459114B51': n,
                '16A42C52-8400-6366-987B-700B15B33ABA': res.data[n],
                dataState: 'create',
                id: UUID.create(),
                index: index
              })
            })
            // 出勤天数
            process.dataService.data['16A35230-AEF0-059F-8313-BEAEBACB22DD'] = (new Date(value.replace(new RegExp(/-/gm), '/')) - new Date(process.dataService.data['16A34C1F-6390-A144-473C-8EEC9DA01BF9'].replace(new RegExp(/-/gm), '/'))) / (24 * 60 * 60 * 1000) + 1 - dataArr.length
          })
        }
      }
    })
  },
  // 居家办公申请
  '17202F6C-0190-0449-4601-C58CA9A4C89B': ({ eventBus, process, el }) => {
    function validate (params, currentNode) {
      params.nodeId = currentNode.id
      if (currentNode.id === '_17202F6C-0190-043E-D17E-2276E4FCB6FE') {
        let times = []
        process.dataService.data['17202F96-8750-047E-28CE-AC3652E2EA00'].forEach(e => times.push(e['17202FB8-0630-0485-0F63-47B69F59B329']))
        times.sort((a, b) => a > b ? 1 : -1)
        if (times.length > 1) {
          moment.locale('en-NZ')
          if (moment(times[0]).week() !== moment(times[ times.length - 1 ]).week()) {
            el.$message({
              message: '所有明细列表日期，必须在同一星期内（周一到周日）',
              type: 'error'
            })
            return true
          }
          return false
        }
      }
      return false
    }
    eventBus.$on('process.beforeStartingProcess', async ({ params, currentNode }) => {
      if (validate(params, currentNode)) {
        el.processLoading = false
        el.processLoadingPercentage = 0
        throw new Error('所有明细列表日期，必须在同一星期内（周一到周日）')
      }
    })
    eventBus.$on('process.beforeSubmit', async ({ params, currentNode }) => {
      if (validate(params, currentNode)) {
        el.processLoading = false
        el.processLoadingPercentage = 0
        throw new Error('所有明细列表日期，必须在同一星期内（周一到周日）')
      }
    })
  },
  // 开店申请
  '16AC4486-A8B0-194C-2C81-DFAA6B8C6029': ({ eventBus, process, el }) => {
    if (el.currentNode.id !== '_177CA42B-FB20-010B-13E9-5929656514B2') {
      el.$router.push({name: 'process-doingTasks'})
    }
    let showIds = ['16BB18DD-37B0-015D-D229-AD388DDDE3E1', '16BE4088-E780-0435-7EF7-7BCBA15F7877', '170BA0DD-9E30-0122-BDF4-E91FC6385500',
      '177BE76A-74D0-0851-9D32-A4F9A55F6C54', '16AC4486-AAE0-1970-59A2-E6E0BF9DAA5A', '16AC4486-ADE0-19E8-25C8-80065D0724BE', '16AC4486-AE10-19EE-0FCD-140CCF61A2EE']
    el.$refs.form[0].$refs.children.forEach(e => {
      if (e.component && showIds.indexOf(e.component.componentId) < 0) {
        if (e.component.componentType !== 'rc-draggable' && e.component.componentType !== 'rc-layout' && e.component.componentType !== 'rc-form' && e.component.componentType !== 'rc-group') {
          el.findAllVue(el).find(n => n.component.componentId === e.component.componentId).component.properties.hidden = true
        }
      }
    })
    // el.$refs.form[1].$el.style.display = 'none'
    let p = document.createElement('p')
    p.innerText = '提示：查看详细信息请登录PC端'
    p.style.color = 'red'
    p.style.textAlign = 'center'
    p.style.paddingTop = '15px'
    p.style.fontSize = '14px'
    el.$refs.form[0].$el.append(p)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/redcatSdk/funitions.js